/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorNextLicenseCheckEndpointResponse
 */
export interface StorNextLicenseCheckEndpointResponse {
    /**
     * 
     * @type {string}
     * @memberof StorNextLicenseCheckEndpointResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StorNextLicenseCheckEndpointResponse
     */
    mac: string;
    /**
     * 
     * @type {string}
     * @memberof StorNextLicenseCheckEndpointResponse
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof StorNextLicenseCheckEndpointResponse
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof StorNextLicenseCheckEndpointResponse
     */
    comment: string;
    /**
     * 
     * @type {boolean}
     * @memberof StorNextLicenseCheckEndpointResponse
     */
    valid: boolean;
}

export function StorNextLicenseCheckEndpointResponseFromJSON(json: any): StorNextLicenseCheckEndpointResponse {
    return StorNextLicenseCheckEndpointResponseFromJSONTyped(json, false);
}

export function StorNextLicenseCheckEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorNextLicenseCheckEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'mac': json['mac'],
        'key': json['key'],
        'type': json['type'],
        'comment': json['comment'],
        'valid': json['valid'],
    };
}

export function StorNextLicenseCheckEndpointResponseToJSON(value?: StorNextLicenseCheckEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'mac': value.mac,
        'key': value.key,
        'type': value.type,
        'comment': value.comment,
        'valid': value.valid,
    };
}


